{
  "version": 1,
  "asset_id": "d4494ad0-9f65-4472-92b9-185bb20e8cbc",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/d4494ad0-9f65-4472-92b9-185bb20e8cbc/hiatal-type-3-sleeve-en-1087.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/d4494ad0-9f65-4472-92b9-185bb20e8cbc/hiatal-type-3-sleeve-en-1087.webp",
  "original_filename": "hiatal-type-3-sleeve-en-1087.webp",
  "size": 86312,
  "content_type": "image/webp",
  "created_at": "2026-09-26T23:10:54Z"
}
